<template>
  <el-main>
    <el-form class="el-form-search" label-width="90px">
      <el-form-item label="战队名称：">
        <el-input size="small" v-model="team_name" placeholder="请输入战队名称"></el-input>
      </el-form-item>
      <el-form-item label="队员名称：">
        <el-input size="small" v-model="user_name" placeholder="请输入队员名称"></el-input>
      </el-form-item>
      <el-form-item label="联系电话：">
        <el-input size="small" v-model="mobile" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label=" " label-width="25px">
        <el-button size="small" type="primary" @click="getDataList(1)">搜索</el-button>
        <el-button size="small" @click="searchClear" type="text">清除搜索条件</el-button>
      </el-form-item>
    </el-form>

    <!-- 展示表格 -->
    <el-table :data="dataList" style="width: 100%" :header-cell-style="{ 'background-color': '#F8F9FA' }">
      <template slot="empty">
        <No />
      </template>
      <el-table-column type="expand">
        <template slot-scope="props">
          <!-- 展示子级 -->
          <el-table :data="props.row.team_user_list" style="width: 100%" :header-cell-style="{ 'background-color': '#F8F9FA' }">
            <el-table-column label="报名人身份" prop="team_name" align="center">
              <template v-slot="{ row }">
                {{ row.is_team_leader ? '队长' : '队员' }}
              </template>
            </el-table-column>
            <el-table-column label="报名人姓名" prop="user_name" align="center"></el-table-column>
            <el-table-column label="联系电话" prop="mobile" align="center"></el-table-column>
            <el-table-column label="QQ号码" prop="qq" align="center"></el-table-column>
            <el-table-column label="段位" prop="dan" align="center"></el-table-column>
            <el-table-column label="擅长位置" prop="preferred_role" align="center"></el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="战队名称" prop="team_name" align="center"></el-table-column>
      <el-table-column label="战队logo" align="center">
        <template v-slot="{ row }">
          <el-image :style="{ width: '50px', height: '50px' }" :preview-src-list="[row.logo]" :src="row.logo"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="报名人姓名" prop="user_name" align="center"></el-table-column>
      <el-table-column label="联系电话" prop="mobile" align="center"></el-table-column>
      <el-table-column label="战队队员数" prop="team_user_count" align="center"></el-table-column>
      <el-table-column label="设置排名" align="center">
        <template v-slot="{ row }">
          <el-input :disabled="row.isRanking" style="width: 100px" size="mini" type="number" v-model="row.ranking" :min="1"></el-input>
          <el-button v-if="!row.isRanking" style="margin-left: 10px" size="small" type="text" @click="sureRank(row)">确认</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-main>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        events_id: 0,
        team_name: '',
        user_name: '',
        mobile: '',
      },
      dataList: [],
      updateRank: '',
    };
  },
  created() {
    if (this.$route.query.events_id) {
      this.searchForm.events_id = Number(this.$route.query.events_id);
    } else {
      this.$router.push('/extension/activity/scheduleList');
    }
    this.getDataList(1);
  },
  methods: {
    updateData(val, status) {
      if (status == 0) {
        this.rows = val;
      } else {
        this.page = val;
      }
      this.getDataList();
    },
    searchClear() {
      this.searchForm.team_name = '';
      this.searchForm.user_name = '';
      this.searchForm.mobile = '';
      this.getDataList(1);
    },
    getDataList(style) {
      if (style) this.page = 1;
      let obj = {
        events_id: this.searchForm.events_id,
        page: this.page,
        rows: this.rows,
      };
      if (this.searchForm.team_name) obj.team_name = this.searchForm.team_name;
      if (this.searchForm.user_name) obj.user_name = this.searchForm.user_name;
      if (this.searchForm.mobile) obj.mobile = this.searchForm.mobile;
      this.$axios.post(this.$api.sports.scheduleTeamRankList, obj).then(res => {
        if (res.code === 0) {
          this.dataList = res.result;
          this.dataList.map(item => {
            if (item.ranking) {
              this.$set(item, 'isRanking', 1);
            } else {
              this.$set(item, 'isRanking', 0);
            }
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 设置队伍排名
    sureRank(data) {
      if (!data.ranking || data.ranking <= 0) {
        this.$message.error('排名不能小于0');
        return;
      }
      this.$axios.post(this.$api.sports.scheduleSetRanking, { team_id: data.id, ranking: data.ranking }).then(res => {
        if (res.code === 0) {
          this.$set(data, 'isRanking', 1);
          this.$message.success('设置成功');
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-main {
  background-color: #fff;
  .el-table {
    .el-input {
      /deep/ input {
        text-align: center;
      }
    }
  }
}
</style>
